'use client';
import * as Tooltip from '@radix-ui/react-tooltip';

export default function TooltipProvider({ children }: { children: React.ReactNode }) {
  return <Tooltip.Provider delayDuration={1000}>{children}</Tooltip.Provider>;
}
